<script lang="ts">
  import type {Notification, User} from '../types'
  import {t} from '../i18n'
  import {Link} from 'svelte5-router'
  import {formatDateTimeRelative} from '../utils/format'

  export let notificationParams: { sender: User }
  export let notification: Notification

  $: sender = notificationParams.sender
</script>

<Link class="item" to={sender.link}>
  <div class="notice-img">
    <img src={sender.avatar_big_thumgb} alt={sender.full_name}/>
  </div>
  <i class="privat-msg-icon icon-p-mail"></i>
  <div class="notice-content">
    <a class="notice-action db">
      <span class="black-txt">{sender.full_name}</span> {t.timelines.received_message}
    </a>
    <i class="notice-time db">{formatDateTimeRelative(notification.created_at)}</i>
  </div>
</Link>